import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { InvoiceSchema } from '../base/invoice.js';
export const GatherInvoiceAdditionalParamsRequestSchema = z.object({
    invoice: InvoiceSchema.pick({ total: true, customer: true }),
    entityId: CornSchema,
});
export const GatherInvoiceAdditionalParamsResponseSchema = z.object({
    additional: z.record(z.string(), z.unknown()).optional(),
});
